module.exports = __webpack_public_path__ + "static/img/league3.6eb4d7bb.png";